window.Entities.Wallets = {}
